import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { knowledgebaseRoutes } from './knowledgebase/knowledgebase-routes';
import { TravelInsuranceRoutesEnum } from './travel-insurance.routes.enum';

const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: TravelInsuranceRoutesEnum.Home,
                loadChildren: () => import('./reisverzekering-product/reisverzekering-product.module').then(m => m.ReisverzekeringProductModule),
            },
            {
                path: TravelInsuranceRoutesEnum.Calculate,
                pathMatch: 'full',
                loadChildren: () => import('./berekenen-reisverzekering/berekenen-reisverzekering.module').then((m) => m.BerekenenReisverzekeringModule),
            },
            {
                path: TravelInsuranceRoutesEnum.Reviews,
                pathMatch: 'full',
                loadChildren: () => import('./reviews/reisverzekering-reviews.module').then((m) => m.ReisverzekeringReviewsModule),
            },
            {
                path: TravelInsuranceRoutesEnum.CancellationInsurance,
                pathMatch: 'full',
                loadChildren: () => import('./annuleringsverzekering/annuleringsverzekering.module').then((m) => m.AnnuleringsverzekeringModule),
            },
            {
                path: TravelInsuranceRoutesEnum.MedicalCostsAbroad,
                pathMatch: 'full',
                loadChildren: () => import('./medische-kosten-op-reis/medische-kosten-op-reis.module').then((m) => m.MedischeKostenOpReisModule),
            },
            {
                path: TravelInsuranceRoutesEnum.VehicleAssistance,
                pathMatch: 'full',
                loadChildren: () => import('./voertuighulp/voertuighulp.module').then((m) => m.VoertuighulpModule),
            },
            ...knowledgebaseRoutes,
        ],
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
    ],
})
export class ReisverzekeringRoutingModule {}
